export default function InitFlerApptus(itemCount, currentPage, isMerAv, isToplist) {
  var methodName = "LoadMoreApptus";

  var path = window.location.pathname;

  var pageSize = $(".selVisaFler").val();
  if (isToplist) {
    methodName = "GetTabProducts";
    pageSize = 25;
  }
  var totalPages = Math.ceil(itemCount / pageSize);
  currentPage = parseInt(currentPage);
  var result = "<ul class='pagination' data-methodname='" + methodName + "'>";
  var selected = "<li class='active'><span>" + currentPage + "</span></li>";
  var last = "<li><a href='" + path + '?p=' + totalPages + "' data-page=\"" + totalPages + "\">" + totalPages + "</a></li>";

  var first = "<li><a href='" + path + '?p=1' + "' data-page=\"1\">1</a></li>";

  var tenPages = '';

  var prevNumber = currentPage - 1;
  var nextNumber = currentPage + 1;

  var next = "<li><a href='" + path + "?p=" + nextNumber + "' aria-label='to the next page' class='next' data-page=\"" + nextNumber + "\"></a></li>";
  var prev = "<li><a href='" + path + "?p=" + prevNumber + "' aria-label='to the prev page' class='prev' data-page=\"" + prevNumber + "\"></a></li>";
  if (currentPage == totalPages) {
    last = selected;
    selected = '';
    next = "<li><span class='next disabled'></span></li>";
  }

  if (currentPage == 1) {
    first = selected;
    selected = '';
    prev = "<li><span class='prev disabled'></span></li>";
  }

  var startIndex;
  var endIndex;
  if (totalPages < 6) {
    startIndex = 2;
    endIndex = totalPages;
  }
  else if (currentPage <= 4) {
    startIndex = 2;
    endIndex = 6;
    last = "<li><span class='dots'>...</span></li>" + last;
  }
  else if ((currentPage + 3) >= totalPages) {
    startIndex = totalPages - 6;
    endIndex = totalPages;
    first += "<li><span class='dots'>...</span></li>";
  }
  else {
    startIndex = currentPage - 2;
    endIndex = currentPage + 3;
    first += "<li><span class='dots'>...</span></li>";
    last = "<li><span class='dots'>...</span></li>" + last;
  }

  for (var i = startIndex; i < endIndex; i++) {
    if (i == currentPage) {
      tenPages += selected;
    }
    else {
      tenPages += "<li><a href='" + path + "?p=" + i + "' data-page=\"" + i + "\">" + i + "</a></li>";
    }
  }

  return result.concat(prev, first, tenPages, last, next, "</ul>");
}